"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _nuiShell = require("@concur/nui-shell");
require("core-js/stable");
require("regenerator-runtime/runtime");
var _react = _interopRequireDefault(require("react"));
var _configureStore = _interopRequireDefault(require("./configureStore"));
var _routes = _interopRequireDefault(require("./routes"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var store = (0, _configureStore.default)(window.__INITIAL_STATE__);
var Root = function Root() {
  return /*#__PURE__*/_react.default.createElement(_nuiShell.NuiClient, {
    store: store,
    routes: _routes.default
  });
};
var _default = exports.default = Root;